/**
 * Initializes an Alpine.js data object to manage a carousel of image cards using Swiper.
 * Key features include:
 * 1. Responsive Carousel: Adapts to screen size with configurable breakpoints.
 * 2. Navigation and Pagination: Supports advanced navigation options and progress bar-style pagination.
 * 3. Dynamic Initialization: Sets up the carousel dynamically upon initialization, ensuring proper display of image cards.
 */

function imageCardCarousel() {
  return {
    swiper: null,
    init() {
      this.cacheNodes();
      this.buildSwiper();
    },

    cacheNodes() {
      this.swiperContainer = document.querySelector('.image-card-carousel');
    },

    buildSwiper() {
      if (this.swiper || !this.swiperContainer) {
        return;
      }
      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 'auto',
        navigation: {
          nextEl: this.swiperContainer.querySelector('.swiper-button-next-image-card'),
          prevEl: this.swiperContainer.querySelector('.swiper-button-prev-image-card'),
        },
        pagination: {
          el: '.pagination-image-card-carousel',
          type: 'progressbar'
        },
        breakpoints: {
          1023: {
            centeredSlides: false,
          },
        },
        on: {
          init: () => {
            setTimeout(() => {}, 100);
          },
        },
      });
    },
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.data('imageCardCarousel', imageCardCarousel);
});
